import { useState } from "react";
import { ReactLenis } from "lenis/react";
import Header from "../components/landing/Header";
import HeroSection from "../components/landing/HeroSection";
import QuizSection from "../components/landing/QuizSection";
import EditorialMarquee from "../components/landing/EditorialMarquee";
import WhereAIBegins from "../components/landing/WhereAIBegins";
import WhyLeadershipLoseSpeed from "../components/landing/WhyLeadershipLoseSpeed";
import UrgencyProofSection from "../components/landing/UrgencyProofSection";
import WhatOnTenacityDelivers from "../components/landing/WhatOnTenacityDoes";
import DecisionQuestions from "../components/landing/DecisionQuestions";
import IndustryEcosystem from "../components/landing/IndustryEcosystem";
import TwoPillars from "../components/landing/TwoPillars";
import HowItWorks from "../components/landing/HowItWorks";
import ModulesSection from "../components/landing/ModulesSection";
import SharedDataSection from "../components/landing/SharedDataSection";
import DiagnosticSection from "../components/landing/DiagnosticSection";
import AISummaryStrip from "../components/landing/AISummaryStrip";
import SecuritySection from "../components/landing/SecuritySection";
import FinalCTA from "../components/landing/FinalCTA";
import Footer from "../components/landing/Footer";
import DiagnosticModal from "../components/landing/DiagnosticModal";
import DemoModal from "../components/landing/DemoModal";

const LandingPage = () => {
  const [diagnosticOpen, setDiagnosticOpen] = useState(false);
  const [demoOpen, setDemoOpen] = useState(false);
  const [quizOpen, setQuizOpen] = useState(false);

  return (
    <ReactLenis
      root
      options={{ lerp: 0.1, duration: 1.2, smoothWheel: true, smoothTouch: false }}
    >
      <div className="min-h-screen bg-[#050505]">
        {/* Film grain texture overlay */}
        <div className="grain-overlay" aria-hidden="true" />

        <Header
          onDiagnosticClick={() => setDiagnosticOpen(true)}
          onDemoClick={() => setDemoOpen(true)}
        />
        <main>
          <HeroSection onStartQuiz={() => setQuizOpen(true)} />
          <EditorialMarquee />
          <WhereAIBegins />
          <WhyLeadershipLoseSpeed />
          <UrgencyProofSection />
          <WhatOnTenacityDelivers />
          <DecisionQuestions />
          <IndustryEcosystem />
          <TwoPillars />
          <HowItWorks />
          <ModulesSection />
          <SharedDataSection />
          <DiagnosticSection onDiagnosticClick={() => setDiagnosticOpen(true)} />
          <AISummaryStrip />
          <SecuritySection />
          <FinalCTA
            onDiagnosticClick={() => setDiagnosticOpen(true)}
            onDemoClick={() => setDemoOpen(true)}
          />
        </main>
        <Footer />

        <QuizSection open={quizOpen} onOpenChange={setQuizOpen} />
        <DiagnosticModal open={diagnosticOpen} onOpenChange={setDiagnosticOpen} />
        <DemoModal open={demoOpen} onOpenChange={setDemoOpen} />
      </div>
    </ReactLenis>
  );
};

export default LandingPage;
